import classnames from "classnames";
import { t } from "@/i18n-js/instance";
import type { QuizAttemptQuestion } from "@/react/types/QuizAttempt";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface QuestionCorrectStatusProps {
  question: QuizAttemptQuestion;
}
export const QuestionCorrectStatus = ({
  question,
}: QuestionCorrectStatusProps) => (
  <div
    className={classnames(
      "mt-2 flex w-full items-center justify-start rounded-md px-4 py-2 leading-5",
      {
        "bg-v2-success-100 text-v2-success": question.correct,
        "bg-v2-danger-100 text-v2-danger": !question.correct,
      },
    )}
  >
    <Icon
      type={`20-${question.correct ? "checkmark" : "close"}`}
      size={20}
      className="mr-2"
    />
    <Typography.LabelSm
      weight="semibold"
      color={question.correct ? "text-v2-success" : "text-v2-danger"}
    >
      {t(
        `courses.view_lesson.quiz_result.question_${
          question.correct ? "correct" : "incorrect"
        }`,
      )}
    </Typography.LabelSm>
  </div>
);
